export default "__VITE_ASSET__DRMdTrhx__"